var _module_exports = "<span>The client has hired another developer, which means you'll no longer be able to see progress.</span>";;
var path = 'views/flashes/private_task.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;